
// components/UserDropdownHeader.jsx - Reusable header component
import React from 'react';
import UserDropdown from './UserDropdown';
import { TRANSCRIPT_NAVIGATION_PADDING } from 'constants/DimensionsConstants';

const PADDING = `${TRANSCRIPT_NAVIGATION_PADDING}px`;

const tabStyle = {
  paddingLeft: PADDING,
  margin: "0px"
};

const UserDropdownHeader = ({
  users,
  selectedUsers,
  onLeftUserSelect,
  onRightUserSelect,
  layout = 'single' // 'single' | 'sideBySide'
}) => {
  if (layout === 'single') {
    return (
      <div style={{ paddingTop: '15px', paddingBottom: '15px' }}>
        <div className="coded-by" style={tabStyle}>
          <UserDropdown
            users={users}
            onSelect={onLeftUserSelect}
            user={selectedUsers.leftUser}
          />
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', paddingTop: '15px', paddingBottom: '15px' }}>
      <div className="coded-by" style={{ flex: 1, ...tabStyle }}>
        <UserDropdown
          users={users}
          onSelect={onLeftUserSelect}
          user={selectedUsers.leftUser}
        />
      </div>
      <div className="coded-by" style={{ flex: 1, ...tabStyle }}>
        <UserDropdown
          users={users}
          onSelect={onRightUserSelect}
          user={selectedUsers.rightUser}
        />
      </div>
    </div>
  );
};

export default UserDropdownHeader;